import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

export class Options {
  bodyClasses: string;

  constructor() {
    this.bodyClasses = '';
  }
}

@Injectable()
export class OptionsService {

  private options: Options;
  public optionsSource = new BehaviorSubject<Options>(this.options);
  public options$ = this.optionsSource.asObservable();

  constructor() {
    this.options = new Options();
  }


  setBodyClasses(classes: string) {
    this.options.bodyClasses = classes;
    this.optionsSource.next(this.options);
  }

}



// WEBPACK FOOTER //
// /var/www/bizisystem-frontend/src/src/app/utils/services/options.service.ts